<template>
  <div>
    <div data-cy="form-label" class="b-dialog__top-panel">
      <h2>{{getAssetName()}}</h2>
      <button class="b-btn b-btn_border_none" @click="cancel">
        <dynamic-icon icon="close" />
      </button>
    </div>
    <form class="col-12 b-form b-dialog__form mt-5">
      <div class="row mb-4">
        <div class="col-8">
          <div class="b-form__container">
            <div class="b-form__container_type_flex">
              <label>{{$t('CONTENT.events.select_contract_event')}}</label>
            </div>
            <cool-select
              :list="commands"
              option-value="name"
              option-text="displayName"
              v-model="selectedCommandName"
              :placeholder="$t('CONTENT.choose')"
              @change="selectCommand($event)"
            ></cool-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <template v-if="selectedCommandName === 'AddAssetComponent'">
            <AddAssetComponent
              :assetId="asset"
              ref="commandComponent"
              @isPaymentCorrect="updateFromValidationStatus"
            />
          </template>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="b-form__container b-form__container_type_flex">
            <button
              class="b-btn b-btn_type_primary"
              type="submit"
              :disabled="!isFormValid"
              @click="save($event)"
            >{{$t('CONTENT.save')}}</button>
            <button
              class="b-btn b-btn_type_empty m-2"
              @click.prevent="cancel"
            >{{$t('CONTENT.cancel')}}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddAssetComponent from "../commands/AddAssetComponent";

export default {
  components: {
    AddAssetComponent,
  },
  props: {
    asset: {
      type: Number,
      required: true
    },
  },

  data() {
    return {
      isFormValid: true,
      commands: [
        {
          displayName: this.$t("CONTENT.events.AddAssetComponent"),
          name: "AddAssetComponent"
        },
      ],
      selectedCommandName: "AddAssetComponent",
    };
  },
  computed: {
    ...mapGetters(["getAssets"]),
    ...mapGetters(["getCurrentContract"]),
    isContractHasManualCharts() {
      return this.getCurrentContract.hasManualCharts;
    },
  },
  methods: {
    selectCommand(command) {
      this.selectedCommandName = command;
    },

    cancel() {
      this.$refs.commandComponent.cancel();
      this.$emit("closeModal");
    },

    save(e) {
      e.preventDefault();
      let saveResult = this.$refs.commandComponent.save();
      if(saveResult) {
        this.$emit("closeModal");
      }
    },
    getAssetName() {
      for (let i = 0; i < this.getAssets.length; i++) {
        if (this.getAssets[i].idInDB === this.asset) {
          return this.getAssets[i].name;
        }
      }
    },
    getAssetComponentName() {
      if (this.assetComponent.name !== null) {
        return ` - ${this.assetComponent.name}`;
      }
    },
    updateFromValidationStatus(value) {
      this.isFormValid = value;
    }
  }
};
</script>
